import SingUpLanding from './Variants/SingUpLanding'
import SingUpResult from './Variants/SingUpResult'
import ChangeEmail from './Variants/ChangeEmail'

export const POPUP_VARIANTS = {
	SING_UP_LANDING: 'sing-up-landing',
	SING_UP_RESULT: 'sing-up-result',
	CHANGE_EMAIL: 'change-email',
}

export const ELEMENT_VARIANTS = {
	[POPUP_VARIANTS.SING_UP_LANDING]: SingUpLanding,
	[POPUP_VARIANTS.SING_UP_RESULT]: SingUpResult,
	[POPUP_VARIANTS.CHANGE_EMAIL]: ChangeEmail,
}
